import React from "react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <>
      {/* Top Footer - Different Style */}
      <footer className="section-t-space top-footer" style={{backgroundColor: "#2c3e50", color: "#fff"}}>
        <div className="container-fluid-lg">
          <div className="service-section">
            <div className="row g-3">
              <div className="col-12">
                <div className="service-contain">
                  <div className="service-box">
                    <div className="service-image">
                      <img
                        src="../assets/svg/product.svg"
                        className="blur-up lazyload"
                        alt="img"
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    </div>
                    <div className="service-detail">
                      <h5 style={{ color: "#fff" }}>Batch-Packed with Care</h5>
                    </div>
                  </div>

                  <div className="service-box">
                    <div className="service-image">
                      <img
                        src="../assets/svg/delivery.svg"
                        className="blur-up lazyload"
                        alt="img"
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    </div>
                    <div className="service-detail">
                      <h5 style={{ color: "#fff" }}>Fast & Reliable Delivery</h5>
                    </div>
                  </div>

                  <div className="service-box">
                    <div className="service-image">
                      <img
                        src="../assets/svg/discount.svg"
                        className="blur-up lazyload"
                        alt="img"
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    </div>
                    <div className="service-detail">
                      <h5 style={{ color: "#fff" }}>Clear, Honest Pricing</h5>
                    </div>
                  </div>

                  <div className="service-box">
                    <div className="service-image">
                      <img
                        src="../assets/svg/market.svg"
                        className="blur-up lazyload"
                        alt="img"
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    </div>
                    <div className="service-detail">
                      <h5 style={{ color: "#fff" }}>Customer-First Support</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Main Footer - Original Style */}
      <footer className="section-t-space" style={{backgroundColor:"#dedfe0"}}>
        <div className="container-fluid-lg">
          <div className="main-footer section-b-space section-t-space d-none d-md-block">
            <div className="row g-md-4 g-3">
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="footer-logo">
                  <div className="theme-logo">
                    <a href="/" style={{ textDecoration: "none" }}>
                      <h2 style={{ fontWeight: 800, fontSize: "35px", color: "#000" }}>
                        EVERCORE
                      </h2>
                    </a>
                  </div>
                  <div className="footer-logo-contain">
                    <p>Clean, transparent nutrition designed for everyday wellness.</p>
                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginTop: '10px' }}>
                      {/* <FaMapMarkerAlt style={{ color: '#666', fontSize: '16px', flexShrink: 0, marginTop: '3px' }} /> */}
                      {/* <p style={{ margin: 0, color: '#666', fontSize: '14px', lineHeight: '1.6' }}>
                        Near Sadar Hospital, Ward No. 11, Bhabua (Kaimur), Bihar – 821101, India
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl col-lg-2 col-sm-3">
                <div className="footer-title"><h4>Policies</h4></div>
                <div className="footer-contain">
                  <ul>
                    <li><a href="/policies/privacy" className="text-content">Privacy Policy</a></li>
                    <li><a href="/policies/terms" className="text-content">Terms & Condition</a></li>
                    <li><a href="/policies/return" className="text-content">Return Policy</a></li>
                    <li><a href="/policies/shipping" className="text-content">Orders and shipping policy</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-xl col-lg-2 col-sm-3">
                <div className="footer-title"><h4>Quick Links</h4></div>
                <div className="footer-contain">
                  <ul>
                    <li><a href="/Shop" className="text-content">Shop</a></li>
                    <li><a href="/Blog" className="text-content">Blog</a></li>
                    <li><a href="/bulk-orders" className="text-content">Bulk Orders</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
                <div className="footer-title"><h4>Evercore Delights</h4></div>
                <div className="footer-contain">
                  <ul>
                    <li><a href="/recipe" className="text-content">Recipe</a></li>
                    <li><a href="/ourstory" className="text-content">Our Story</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-xl col-lg-2 col-sm-3">
                <div className="footer-title"><h4>Help</h4></div>
                <div className="footer-contain">
                  <ul>
                    <li><a href="/Faq" className="text-content">FAQ</a></li>
                    <li><a href="/Contact" className="text-content">Contact Us</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="footer-title"><h4>Contact Us</h4></div>
                <div className="footer-contact">
                  <ul>
                    <li>
                      <div className="footer-number">
                        <FaPhone style={{ color: '#666', fontSize: '18px', flexShrink: 0 }} />
                        <div className="contact-number">
                          <h6 className="text-content">Contact Us :</h6>
                          <h5>+91 89699 77190</h5>
                          <h6 className="text-content" style={{ marginTop: '10px' }}>Customer Support Hours :</h6>
                          <h5>10:00 AM - 6:00 PM</h5>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="footer-number">
                        <FaEnvelope style={{ color: '#666', fontSize: '18px', flexShrink: 0 }} />
                        <div className="contact-number">
                          <h6 className="text-content">Email Address :</h6>
                          <h5>admin@evercorenutrition.com</h5>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="sub-footer section-small-space bottom-footer" style={{ borderTop: "1px solid #ccc", marginTop: "20px", paddingTop: "20px" }}>
            <div>
              <h6 className="text-content" style={{ color: "#666", textAlign: "center" }}>
                Copyright © 2025 Evercore. All rights reserved. Powered By{" "}
                <a href="https://successinnovativetechnologiespvtltd.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#1f2ab8", textDecoration: "underline" }}>
                  Success Innovative Technologies Pvt. Ltd.
                </a>
              </h6>
            </div>
          </div>
        </div>
      </footer>

      <style>{`
        /* ── Service Contain: horizontal scroll on mobile & tablet ── */
        @media (max-width: 991px) {
          .service-section .service-contain {
            display: flex !important;
            flex-wrap: nowrap !important;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            scroll-snap-type: x mandatory;
            gap: 0;
            padding-bottom: 10px;

            /* hide scrollbar visually but keep it functional */
            scrollbar-width: none;        /* Firefox */
            -ms-overflow-style: none;     /* IE/Edge */
          }

          .service-section .service-contain::-webkit-scrollbar {
            display: none;                /* Chrome/Safari */
          }

          .service-section .service-contain .service-box {
            flex: 0 0 55vw;              /* ~2 cards visible at once on tablet */
            max-width: 220px;
            scroll-snap-align: start;
            padding: 16px 12px;
          }
        }

        @media (max-width: 575px) {
          .service-section .service-contain .service-box {
            flex: 0 0 70vw;              /* ~1.4 cards visible on mobile */
            max-width: 200px;
          }
        }

        /* ── Scroll hint fade on right edge ── */
        @media (max-width: 991px) {
          .service-section {
            position: relative;
          }

          .service-section::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 48px;
            height: 100%;
            background: linear-gradient(to right, transparent, #2c3e50);
            pointer-events: none;
            z-index: 1;
          }
        }

        /* ── Existing styles (unchanged) ── */
        .footer-number {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
        }
        .footer-number .contact-number { flex: 1; }
        .footer-number h6 { margin: 0 0 4px 0; font-size: 13px; }
        .footer-number h5 { margin: 0; font-size: 14px; font-weight: 600; color: #333; }

        .footer-address { transition: all 0.3s ease; }
        .footer-address:hover { transform: translateX(5px); }
        .footer-address p { transition: color 0.3s ease; }
        .footer-address:hover p { color: #000; }
        .footer-address svg { transition: color 0.3s ease; }
        .footer-address:hover svg { color: #1f2ab8; }

        .top-footer { border-bottom: 3px solid #1f2ab8; }
        .top-footer .service-box { transition: transform 0.3s ease; }
        .top-footer .service-box:hover { transform: translateY(-5px); }
        .top-footer .service-detail h5 { transition: color 0.3s ease; }
        .top-footer .service-box:hover .service-detail h5 { color: #1815b6 !important; }

        .bottom-footer { transition: all 0.3s ease; }
        .bottom-footer:hover { opacity: 0.9; }
      `}</style>
    </>
  );
};

export default Footer;